import { paths } from "../paths";
import type { RegistrationDraftState } from "../../models/zustand.model";

export type Draft = Pick<
  RegistrationDraftState,
  "artomeSerialNo" | "epsonSerialNo" | "productName" | "ownerCompanyName"
>;

export interface RegisterStep {
  path: string;
  label: string;
  /** Whether the draft holds enough to legitimately be on this step. */
  requires: (draft: Draft) => boolean;
}

/**
 * One config driving the stepper, the route guards and back navigation.
 *
 * The guards are what stop a hand-typed `/register/summary` from rendering an
 * empty summary — the previous implementation showed a "Missing Fields" list
 * instead of preventing the state.
 */
export const REGISTER_STEPS: readonly RegisterStep[] = [
  {
    path: paths.registerSerial,
    label: "Artome serial",
    requires: () => true,
  },
  {
    path: paths.registerProjector,
    label: "Projector serial",
    requires: (d) => Boolean(d.artomeSerialNo && d.productName),
  },
  {
    path: paths.registerOwner,
    label: "Owner",
    requires: (d) => Boolean(d.artomeSerialNo && d.productName && d.epsonSerialNo),
  },
  {
    path: paths.registerSummary,
    label: "Confirm",
    requires: (d) =>
      Boolean(
        d.artomeSerialNo && d.productName && d.epsonSerialNo && d.ownerCompanyName
      ),
  },
];

/** First step whose prerequisites are not met — where an invalid deep link goes. */
export function firstIncompleteStep(draft: Draft): RegisterStep {
  return (
    REGISTER_STEPS.find((step) => !step.requires(draft)) ??
    REGISTER_STEPS[REGISTER_STEPS.length - 1]
  );
}

export function stepIndexForPath(pathname: string): number {
  return REGISTER_STEPS.findIndex((step) => step.path === pathname);
}
